import React from 'react'
import InfoDetail from './InfoDetail'
import VariantDetail from './VariantDetail'
import AboutDetail from './AboutDetail'
import { Tabs } from 'antd'
import TargetCropsDetail from './TargetCropsDetail'
import TargetAnimalsDetail from './TargetAnimalsDetail'
import { languageItems } from '../../../../../utils/languages'

const DetailedProduct = ({ productbase, detail }) => {
    const items = languageItems.map(({ key, lang }) => ({
        key,
        label: lang,
        children: <AboutDetail lang={lang} langKey={key} productbase={productbase} detail={detail} />
    }));
    return (
        <div
            className="accordion accordion-solid accordion-toggle-plus"
            id="vender_product_preview"
        >
            <InfoDetail productbase={productbase} detail={detail} />
            <VariantDetail productbase={productbase} detail={detail} />
            <div className="separator separator-solid my-5"></div>
            <Tabs defaultActiveKey="1" items={items} />
            {productbase !== "MACHINERY" &&
                (productbase !== "SEEDS" &&
                    (productbase === "FEED_SUPPLEMENT" ? <TargetAnimalsDetail productbase={productbase} detail={detail}/> :
                    <TargetCropsDetail productbase={productbase} detail={detail} />))}
        </div>
    )
}

export default DetailedProduct